import { render } from "./RectangleSelectComponent.vue?vue&type=template&id=6ab1b902"
import script from "./RectangleSelectComponent.vue?vue&type=script&lang=js"
export * from "./RectangleSelectComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__